module.exports = __webpack_public_path__ + "static/media/eea-logo-white.da328514.svg";